export const floors = [
  // 1-60 তলা
  ...Array.from({ length: 60 }, (_, i) => i.toString()),

  // বেসিক ফ্লোর টাইপ
  "GF",
  "Terrace",
  "4th",
  "TF",
  "SF",
  "FF",
  "UGF",
  "BMT",
  "Stilt",

  // GF কম্বিনেশন
  "GF+Terrace",
  "GF+4th",
  "GF+4th+Terrace",
  "GF+TF",
  "GF+TF+Terrace",
  "GF+TF+4th",
  "GF+TF+4th+Terrace",
  "GF+SF",
  "GF+SF+Terrace",
  "GF+SF+4th",
  "GF+SF+4th+Terrace",
  "GF+SF+TF",
  "GF+SF+TF+Terrace",
  "GF+SF+TF+4th",
  "GF+SF+TF+4th+Terrace",

  // 4th কম্বিনেশন
  "4th+Terrace",
  "4th+TF",
  "4th+TF+Terrace",
  "4th+SF",
  "4th+SF+Terrace",
  "4th+SF+TF",
  "4th+SF+TF+Terrace",

  // TF কম্বিনেশন
  "TF+Terrace",
  "TF+4th",
  "TF+4th+Terrace",
  "TF+SF",
  "TF+SF+Terrace",
  "TF+SF+4th",
  "TF+SF+4th+Terrace",

  // SF কম্বিনেশন
  "SF+Terrace",
  "SF+4th",
  "SF+4th+Terrace",
  "SF+TF",
  "SF+TF+Terrace",
  "SF+TF+4th",
  "SF+TF+4th+Terrace",

  // FF কম্বিনেশন
  "FF+Terrace",
  "FF+4th",
  "FF+4th+Terrace",
  "FF+TF",
  "FF+TF+Terrace",
  "FF+TF+4th",
  "FF+TF+4th+Terrace",
  "FF+SF",
  "FF+SF+Terrace",
  "FF+SF+4th",
  "FF+SF+4th+Terrace",
  "FF+SF+TF",
  "FF+SF+TF+Terrace",
  "FF+SF+TF+4th",
  "FF+SF+TF+4th+Terrace",

  // UGF কম্বিনেশন
  "UGF+Terrace",
  "UGF+4th",
  "UGF+4th+Terrace",
  "UGF+TF",
  "UGF+TF+Terrace",
  "UGF+TF+4th",
  "UGF+TF+4th+Terrace",
  "UGF+SF",
  "UGF+SF+Terrace",
  "UGF+SF+4th",
  "UGF+SF+4th+Terrace",
  "UGF+SF+TF",
  "UGF+SF+TF+Terrace",
  "UGF+SF+TF+4th",
  "UGF+SF+TF+4th+Terrace",
  "UGF+FF",
  "UGF+FF+Terrace",
  "UGF+FF+4th",
  "UGF+FF+4th+Terrace",
  "UGF+FF+TF",
  "UGF+FF+TF+Terrace",
  "UGF+FF+TF+4th",
  "UGF+FF+TF+4th+Terrace",
  "UGF+FF+SF",
  "UGF+FF+SF+Terrace",
  "UGF+FF+SF+4th",
  "UGF+FF+SF+4th+Terrace",
  "UGF+FF+SF+TF",
  "UGF+FF+SF+TF+Terrace",
  "UGF+FF+SF+TF+4th",
  "UGF+FF+SF+TF+4th+Terrace",

  // BMT কম্বিনেশন
  "BMT+Terrace",
  "BMT+4th",
  "BMT+4th+Terrace",
  "BMT+TF",
  "BMT+TF+Terrace",
  "BMT+TF+4th",
  "BMT+TF+4th+Terrace",
  "BMT+SF",
  "BMT+SF+Terrace",
  "BMT+SF+4th",
  "BMT+SF+4th+Terrace",
  "BMT+SF+TF",
  "BMT+SF+TF+Terrace",
  "BMT+SF+TF+4th",
  "BMT+SF+TF+4th+Terrace",
  "BMT+FF",
  "BMT+FF+Terrace",
  "BMT+FF+4th",
  "BMT+FF+4th+Terrace",
  "BMT+FF+TF",
  "BMT+FF+TF+Terrace",
  "BMT+FF+TF+4th",
  "BMT+FF+TF+4th+Terrace",
  "BMT+FF+SF",
  "BMT+FF+SF+Terrace",
  "BMT+FF+SF+4th",
  "BMT+FF+SF+4th+Terrace",
  "BMT+FF+SF+TF",
  "BMT+FF+SF+TF+Terrace",
  "BMT+FF+SF+TF+4th",
  "BMT+FF+SF+TF+4th+Terrace",
  "BMT+UGF",
  "BMT+UGF+Terrace",
  "BMT+UGF+4th",
  "BMT+UGF+4th+Terrace",
  "BMT+UGF+TF",
  "BMT+UGF+TF+Terrace",
  "BMT+UGF+TF+4th",
  "BMT+UGF+TF+4th+Terrace",
  "BMT+UGF+SF",
  "BMT+UGF+SF+Terrace",
  "BMT+UGF+SF+4th",
  "BMT+UGF+SF+4th+Terrace",
  "BMT+UGF+SF+TF",
  "BMT+UGF+SF+TF+Terrace",
  "BMT+UGF+SF+TF+4th",
  "BMT+UGF+SF+TF+4th+Terrace",
  "BMT+UGF+FF",
  "BMT+UGF+FF+Terrace",
  "BMT+UGF+FF+4th",
  "BMT+UGF+FF+4th+Terrace",
  "BMT+UGF+FF+TF",
  "BMT+UGF+FF+TF+Terrace",
  "BMT+UGF+FF+TF+4th",
  "BMT+UGF+FF+TF+4th+Terrace",
  "BMT+UGF+FF+SF",
  "BMT+UGF+FF+SF+Terrace",
  "BMT+UGF+FF+SF+4th",
  "BMT+UGF+FF+SF+4th+Terrace",
  "BMT+UGF+FF+SF+TF",
  "BMT+UGF+FF+SF+TF+Terrace",
  "BMT+UGF+FF+SF+TF+4th",
  "BMT+UGF+FF+SF+TF+4th+Terrace",

  // Stilt কম্বিনেশন
  "Stilt+Terrace",
  "Stilt+4th",
  "Stilt+4th+Terrace",
  "Stilt+TF",
  "Stilt+TF+Terrace",
  "Stilt+TF+4th",
  "Stilt+TF+4th+Terrace",
  "Stilt+SF",
  "Stilt+SF+Terrace",
  "Stilt+SF+4th",
  "Stilt+SF+4th+Terrace",
  "Stilt+SF+TF",
  "Stilt+SF+TF+Terrace",
  "Stilt+SF+TF+4th",
  "Stilt+SF+TF+4th+Terrace",
  "Stilt+FF",
  "Stilt+FF+Terrace",
  "Stilt+FF+4th",
  "Stilt+FF+4th+Terrace",
  "Stilt+FF+TF",
  "Stilt+FF+TF+Terrace",
  "Stilt+FF+TF+4th",
  "Stilt+FF+TF+4th+Terrace",
  "Stilt+FF+SF",
  "Stilt+FF+SF+Terrace",
  "Stilt+FF+SF+4th",
  "Stilt+FF+SF+4th+Terrace",
  "Stilt+FF+SF+TF",
  "Stilt+FF+SF+TF+Terrace",
  "Stilt+FF+SF+TF+4th",
  "Stilt+FF+SF+TF+4th+Terrace",
  "Stilt+UGF",
  "Stilt+UGF+Terrace",
  "Stilt+UGF+4th",
  "Stilt+UGF+4th+Terrace",
  "Stilt+UGF+TF",
  "Stilt+UGF+TF+Terrace",
  "Stilt+UGF+TF+4th",
  "Stilt+UGF+TF+4th+Terrace",
  "Stilt+UGF+SF",
  "Stilt+UGF+SF+Terrace",
  "Stilt+UGF+SF+4th",
  "Stilt+UGF+SF+4th+Terrace",
  "Stilt+UGF+SF+TF",
  "Stilt+UGF+SF+TF+Terrace",
  "Stilt+UGF+SF+TF+4th",
  "Stilt+UGF+SF+TF+4th+Terrace",
  "Stilt+UGF+FF",
  "Stilt+UGF+FF+Terrace",
  "Stilt+UGF+FF+4th",
  "Stilt+UGF+FF+4th+Terrace",
  "Stilt+UGF+FF+TF",
  "Stilt+UGF+FF+TF+Terrace",
  "Stilt+UGF+FF+TF+4th",
  "Stilt+UGF+FF+TF+4th+Terrace",
  "Stilt+UGF+FF+SF",
  "Stilt+UGF+FF+SF+Terrace",
  "Stilt+UGF+FF+SF+4th",
  "Stilt+UGF+FF+SF+4th+Terrace",
  "Stilt+UGF+FF+SF+TF",
  "Stilt+UGF+FF+SF+TF+Terrace",
  "Stilt+UGF+FF+SF+TF+4th",
  "Stilt+UGF+FF+SF+TF+4th+Terrace",
  "Stilt+BMT",
  "Stilt+BMT+Terrace",
  "Stilt+BMT+4th",
  "Stilt+BMT+4th+Terrace",
  "Stilt+BMT+TF",
  "Stilt+BMT+TF+Terrace",
  "Stilt+BMT+TF+4th",
  "Stilt+BMT+TF+4th+Terrace",
  "Stilt+BMT+SF",
  "Stilt+BMT+SF+Terrace",
  "Stilt+BMT+SF+4th",
  "Stilt+BMT+SF+4th+Terrace",
  "Stilt+BMT+SF+TF",
  "Stilt+BMT+SF+TF+Terrace",
  "Stilt+BMT+SF+TF+4th",
  "Stilt+BMT+SF+TF+4th+Terrace",
  "Stilt+BMT+FF",
  "Stilt+BMT+FF+Terrace",
  "Stilt+BMT+FF+4th",
  "Stilt+BMT+FF+4th+Terrace",
  "Stilt+BMT+FF+TF",
  "Stilt+BMT+FF+TF+Terrace",
  "Stilt+BMT+FF+TF+4th",
  "Stilt+BMT+FF+TF+4th+Terrace",
  "Stilt+BMT+FF+SF",
  "Stilt+BMT+FF+SF+Terrace",
  "Stilt+BMT+FF+SF+4th",
  "Stilt+BMT+FF+SF+4th+Terrace",
  "Stilt+BMT+FF+SF+TF",
  "Stilt+BMT+FF+SF+TF+Terrace",
  "Stilt+BMT+FF+SF+TF+4th",
  "Stilt+BMT+FF+SF+TF+4th+Terrace",
  "Stilt+BMT+UGF",
  "Stilt+BMT+UGF+Terrace",
  "Stilt+BMT+UGF+4th",
  "Stilt+BMT+UGF+4th+Terrace",
  "Stilt+BMT+UGF+TF",
  "Stilt+BMT+UGF+TF+Terrace",
  "Stilt+BMT+UGF+TF+4th",
  "Stilt+BMT+UGF+TF+4th+Terrace",
  "Stilt+BMT+UGF+SF",
  "Stilt+BMT+UGF+SF+Terrace",
  "Stilt+BMT+UGF+SF+4th",
  "Stilt+BMT+UGF+SF+4th+Terrace",
  "Stilt+BMT+UGF+SF+TF",
  "Stilt+BMT+UGF+SF+TF+Terrace",
  "Stilt+BMT+UGF+SF+TF+4th",
  "Stilt+BMT+UGF+SF+TF+4th+Terrace",
  "Stilt+BMT+UGF+FF",
  "Stilt+BMT+UGF+FF+Terrace",
  "Stilt+BMT+UGF+FF+4th",
  "Stilt+BMT+UGF+FF+4th+Terrace",
  "Stilt+BMT+UGF+FF+TF",
  "Stilt+BMT+UGF+FF+TF+Terrace",
  "Stilt+BMT+UGF+FF+TF+4th",
  "Stilt+BMT+UGF+FF+TF+4th+Terrace",
  "Stilt+BMT+UGF+FF+SF",
  "Stilt+BMT+UGF+FF+SF+Terrace",
  "Stilt+BMT+UGF+FF+SF+4th",
  "Stilt+BMT+UGF+FF+SF+4th+Terrace",
  "Stilt+BMT+UGF+FF+SF+TF",
  "Stilt+BMT+UGF+FF+SF+TF+Terrace",
  "Stilt+BMT+UGF+FF+SF+TF+4th",
  "Stilt+BMT+UGF+FF+SF+TF+4th+Terrace",
];
